"use client";
import { useMemo } from "react";

import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import ProductBarChart from "../ProductBarChart/ProductBarChart";
import { ProductBarChartTransaction } from "../ProductBarChart/types";
import { ViewType } from "../types";
import { Top5FlightRoutesTransactionsResult } from "./types";
import { buildRouteLabel } from "./utils";

type Props = {
  data: Top5FlightRoutesTransactionsResult;
  viewType?: ViewType;
  interactive?: boolean;
};

export default function TopFlightRoutesBarChart({
  data,
  viewType,
  interactive,
}: Props) {
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();

  const transactions: ProductBarChartTransaction[] = useMemo(
    () =>
      data.top5FlightRoutesTransactions.transactions.map((t) => ({
        month: t.month,
        year: t.year,
        quarter: t.quarter,
        sortDate: t.truncatedDate,
        entries: t.routes.map((r) => ({
          name: buildRouteLabel(r.route, r.city),
          value: r.amount,
        })),
      })),
    [data]
  );

  return (
    <ProductBarChart
      transactions={transactions}
      note={cr.inBillions}
      viewType={viewType}
      interactive={interactive}
    />
  );
}
